var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAlternate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199.413,
    height: 80.407,
    viewBox: "0 0 199.413 80.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:url(#h);}.i{fill:url(#i);}.j{clip-path:url(#j);}.k{clip-path:url(#l);}.l{clip-path:url(#n);}.m{fill:url(#p);}.n{clip-path:url(#q);}.o{clip-path:url(#s);}.p{clip-path:url(#u);}.q{clip-path:url(#w);}.r{clip-path:url(#y);}.s{clip-path:url(#aa);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b52326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#560e11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.164,
    y1: 0.5,
    x2: 1.149,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.285,
    y1: 0.5,
    x2: 1.225,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.243,
    y1: 0.5,
    x2: 1.157,
    y2: 0.632,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.647,
    x2: 0.927,
    y2: 0.647,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323a87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211d57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y1: 0.607,
    x2: 1,
    y2: 0.6,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.033,
    y1: 0.5,
    x2: 1.082,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.161,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.618,50.068A2.562,2.562,0,1,0,82.173,47.7a2.466,2.466,0,0,0-2.555,2.369",
    transform: "translate(-79.618 -47.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M70.395,59.1a2.742,2.742,0,1,0,2.742-2.742A2.742,2.742,0,0,0,70.395,59.1",
    transform: "translate(-70.395 -56.362)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.979,67.655a2.375,2.375,0,1,0,2.374-2.367,2.371,2.371,0,0,0-2.374,2.367",
    transform: "translate(-79.979 -65.288)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b52326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b1213"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M88.561,58.684a2.609,2.609,0,1,0,2.6-2.415,2.513,2.513,0,0,0-2.6,2.415",
    transform: "translate(-88.561 -56.269)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M99.847,71.794h7.462a8.319,8.319,0,0,1,0,16.638H99.847ZM97.22,69.167v28.9h2.627V91.059h7.462a11.11,11.11,0,0,0,3.328-.49l3.818,7.5H117.4l-4.379-8.581a11.854,11.854,0,0,0,2.031-1.647,10.946,10.946,0,0,0-7.74-18.67H97.22Z",
    transform: "translate(-97.22 -69.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M138.45,75.3l-6.621,9.142L125.174,75.3h-3.258l8.266,11.383-8.266,11.385h3.258l6.655-9.142,6.621,9.142h3.257L133.44,86.68,141.707,75.3Z",
    transform: "translate(-121.916 -75.298)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M180.221,69.167,167.575,86.751,154.86,69.167h-2.172v28.9h2.627V74.281l11.1,15.377h2.312l11.1-15.447V98.065h2.627v-28.9Z",
    transform: "translate(-152.688 -69.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M193.164,93.494A9.648,9.648,0,0,1,206.808,79.85a10.27,10.27,0,0,1,1.927,2.732v8.2a9.73,9.73,0,0,1-1.927,2.7,9.638,9.638,0,0,1-13.644.018m-1.856-15.483a12.26,12.26,0,0,0,8.669,20.93,11.959,11.959,0,0,0,8.758-3.679v2.8h2.627v-22.8h-2.627V78.1a11.963,11.963,0,0,0-8.758-3.679,11.814,11.814,0,0,0-8.669,3.591",
    transform: "translate(-187.717 -74.421)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M232.449,75.3l-6.62,9.142L219.173,75.3h-3.258l8.267,11.383-8.267,11.385h3.258l6.656-9.142,6.62,9.142h3.258L227.441,86.68,235.707,75.3Z",
    transform: "translate(-215.915 -75.298)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.294 -19.463)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(79.618 47.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.11,
    height: 4.737
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(70.395 56.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.484,
    height: 5.484
  })), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(79.979 65.288)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.749,
    height: 4.736
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.465 19.461)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-10364.205-213.12a8.386,8.386,0,0,1-1.764-.724c-2.44-1.344-9.074-5.7-9.54-13.572a12.2,12.2,0,0,1,3.435-9.15l15.771-16.417-16.972-16.651a8.51,8.51,0,0,1-1.717-2.388c-1.383-2.881-3.18-9.189,3.04-15.682A15.889,15.889,0,0,1-10360.51-293c3.821,0,7.783,1.589,11.414,5.089.283.273.541.583.81.9l11.966,11.59,2.325,2.261s2.35,1.729-1.661,4.428l-15.308,15.625,14.972,13.851a16.043,16.043,0,0,0,1.4,1.159c1.106.807,3.292,2.735,1.544,4.266l-15.239,15.622s-4.814,5.618-12.065,5.617A14.446,14.446,0,0,1-10364.205-213.12Zm10.187-37.12-14.708,14.708s-6.73,7.228,0,15.208c0,0,3.683,3.982,8.84,3.982a11.559,11.559,0,0,0,7.613-3.112l15.518-15.268-16.766-15.893Zm-11.9-38.264c-9.759,5.655-6.379,13.721-4.667,16.677a7.8,7.8,0,0,0,1.394,1.766l15.611,14.773,16.328-16.391-14.583-13.71a11.325,11.325,0,0,0-8.845-4.232A12.839,12.839,0,0,0-10365.922-288.5Z",
    transform: "translate(10378.171 292.999)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "translate(88.561 56.269)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 5.204,
    height: 4.829
  })), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(97.22 69.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 21.017,
    height: 28.898
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(121.916 75.298)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.791,
    height: 22.768
  })), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(152.688 69.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 29.775,
    height: 28.898
  })), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(187.717 74.421)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 23.645,
    height: 24.521
  })), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(215.915 75.298)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 19.792,
    height: 22.768
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlternate);
export default __webpack_public_path__ + "static/media/logoAlternate.dd62e88f37b189a20975d4618e6a3155.svg";
export { ForwardRef as ReactComponent };